// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/in_app_message_color_profiles(/:id)" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementInAppMessageColorProfilesId } from "./constants";
import type { EngagementIamTemplateAdditionalParams, GetIamTemplateResultOrResults } from "./types";

/**
 * Retrieve either a single result (when `id` is passed) or all results
 */
export const getEngagementInAppMessageColorProfilesId = reactQueryFetcherAdapter(
  engagementInAppMessageColorProfilesId,
  (
    signal: AbortSignal,
    id?: string,
    additionalParams?: EngagementIamTemplateAdditionalParams
  ): Promise<GetIamTemplateResultOrResults> => {
    return fetch(
      `/engagement/in_app_message_color_profiles${id ? `/${id}` : ""}`,
      "GET",
      {
        ...(id ? {} : additionalParams),
      },
      { signal }
    );
  }
);
